export const companyOptions = ['AIB', 'Bank Of Ireland', 'Revolut', 'Permanent TSB'];
export const methodOptions = ['Phone (Call)', 'Phone (SMS)', 'Email', 'In House Visit']
export const tierOptions = ['Free','Pre-Registered']